export default "__VITE_ASSET__BQW8T129__"